import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
    const { data, error } = await supabase.from('studentappcheckview').select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getDataWithType(type) {
    const { data, error } = await supabase.from('studentappcheckview').select().eq('type',type);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  

  export async function getIdData(id) {
    const { data, error } = await supabase.from('studentappcheckview').select()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getStudentIdData(id) {
    const prm = `studentId.eq.${id},studentId.is.null`;
    const { data, error } = await supabase.from('studentappcheckview').select()
    //.eq('studentId', id);
    .or(prm);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function addData(adata) {
    const { data, error } = await supabase.from('studentappcheckview').insert(adata).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    console.log("udata",udata);
    const { data, error } = await supabase.from('studentappcheckview').update(udata).eq('id', udata.id).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('studentappcheckview').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }